import { IRoom } from './room';
import { IUser } from './users';
import { TIntervalTypeValue } from './intervals';
import { TMeetingSetup } from './meetingSetup';
import { IMeetingConfirmation, IOuterMemberConfirmation } from "./meetingConfirmation";
import { IOuterMembers, IOuterMembersDto } from './outerMembers';

export const Formats = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

export const RepeatTypes = {
  NEVER: 'NEVER',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
};

export const ModifyRecurringMeetingTypes = {
  ONLY_THIS_MEETING: 'ONLY_THIS_MEETING',
  THIS_AND_SUBSEQUENT_MEETINGS: 'THIS_AND_SUBSEQUENT_MEETINGS',
  ALL_MEETINGS: 'ALL_MEETINGS',
};

export type TFormats = typeof Formats[keyof typeof Formats];
export type TRepeatTypes = typeof RepeatTypes[keyof typeof RepeatTypes];
export type TModifyRecurringType = typeof ModifyRecurringMeetingTypes[keyof typeof ModifyRecurringMeetingTypes];

export interface IUpdatedValuesWhenDragging {// новые значения. Обновляются при движении встречи
  startDate: Date;
  endDate: Date;
  layer: number;
};

export interface IMeeting {
  meetingName: string;
  description: string;
  startDate: Date;
  endDate: Date;
  oldStartDate: Date;
  oldEndDate: Date;
  id: number;
  initiator: IUser;
  calendarName: string;
  calendarId: number; // -1 = внутренняя встреча
  calendarColor: string; // #HEX
  intervalType: TIntervalTypeValue;
  repeatType: TRepeatTypes;
  meetingSetup: TMeetingSetup;
  modifyRecurringMeetingType: TModifyRecurringType;

  // параметры внутренней встречи
  format?: TFormats;
  room?: IRoom;
  link?: string;
  members?: IUser[];
  outerMembers?: IOuterMembers[];
  meetingConfirmation?: IMeetingConfirmation[];
  outerMemberConfirmation?: IOuterMemberConfirmation[];

  layer: number;  // уровень(слой) вложенности, layer d= 0: ширина = 100%, zIndex = 0
  draggingValues?: IUpdatedValuesWhenDragging;
}

export interface IEndMeetingRequest {
  meetingId: number;
  oldStartMeetingDate: string;
  oldEndMeetingDate: string;
}

export interface IMeetingDto {
  meetingName: string;
  description: string;
  startMeetingDate: string;
  endMeetingDate: string;
  meetingId: number;
  initiator: number;
  calendarName: string;
  calendarId: number; // -1 = внутренняя встреча
  calendarColor: string; // #HEX
  intervalType: TIntervalTypeValue;
  repeatType: TRepeatTypes;
  meetingSetup: TMeetingSetup;
  meetingConfirmation: IMeetingConfirmation[];
  meetingConfirmationForOuterUsers: IOuterMemberConfirmation[];

  // параметры внутренней встречи
  meetingType?: TFormats;
  conferenceRoom?: IRoom;
  link?: string;
  members?: number[];
  outerMembers?: IOuterMembers[];
}

export interface IMeetingToDto {
  meetingName: string;
  description: string;
  startMeetingDate: string;
  endMeetingDate: string;
  oldStartMeetingDate: string;
  oldEndMeetingDate: string;
  meetingId?: number;
  meetingType: TFormats;
  conferenceRoom?: string;
  link?: string;
  participantIdsList: number[];
  intervalType: string;
  meetingSetup: TMeetingSetup;
  modifyRecurringMeetingType: TModifyRecurringType;
  outerMembers: IOuterMembersDto[];
}

export interface IMeetingDeleteDto {
  meetingId: number;
  remoteMeetingDate: string;
  modifyRecurringMeetingType: TModifyRecurringType;
}

export type TSplitedMeetings = Map<number | string, IMeeting[]>;
export type TCalendarType = 'inner_meeting' | 'outer_meeting';